import { Badge } from 'reactstrap'
import { renderDateTime } from '../../utils/dateFormatter'
import { UserSummary } from '../../services/endpoints/service29'

export const renderUser = ({ value }: { value: UserSummary | null }) =>
  value ? `${value.username}` : '—'

export const renderDate = ({ value }: { value: string | null }) =>
  value ? renderDateTime({ value }) : '—'

export const makeStatusRenderer =
  (config: Record<string, { label: string; color: string }>) =>
  ({ value }: { value: string }) => {
    const c = config[value] ?? { label: value, color: 'secondary' }
    return <Badge color={c.color}>{c.label}</Badge>
  }
